import React, {ComponentType} from "react";
import {css, Theme} from "@emotion/react";

import {borderRadius, calculateRemSize, flexAbsoluteCenter, p} from "@pg-design/helpers-css";
import {IIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    icon: ComponentType<IIcon>;
    text: string;
    isArchived?: boolean;
    isUnavailable?: boolean;
}

export const OfferBoxPill = (props: IProps) => {
    const Icon = props.icon;

    return (
        <div css={wrapperStyle}>
            {!props.isArchived && (
                <div css={iconWrapperStyle}>
                    <Icon size="1.6" />
                </div>
            )}
            <Text variant="info_txt_1" color={props.isArchived || props.isUnavailable ? "var(--colors-gray-100)" : "var(--colors-secondary)"} strong>
                {getPillText(props.text, props.isArchived, props.isUnavailable)}
            </Text>
        </div>
    );
};

const getPillText = (text: string, isArchived?: boolean, isUnavailable?: boolean) => {
    if (isUnavailable) {
        return "Oferta nieaktywna";
    }
    if (isArchived) {
        return "Oferta archiwalna";
    }
    return text;
};

const wrapperStyle = (theme: Theme) => css`
    ${p(0, 1)};
    display: inline-flex;
    align-items: center;
    background-color: ${theme.colors.gray[200]};
    ${borderRadius(1)};
    gap: ${calculateRemSize(1)};
    height: ${calculateRemSize(3)};
    user-select: none;
`;

const iconWrapperStyle = css`
    ${flexAbsoluteCenter};
    width: ${calculateRemSize(2)};
    height: ${calculateRemSize(2)};
`;
import React, {ComponentType} from "react";
import {css, Theme} from "@emotion/react";

import {borderRadius, calculateRemSize, flexAbsoluteCenter, p} from "@pg-design/helpers-css";
import {IIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    icon: ComponentType<IIcon>;
    text: string;
    isArchived?: boolean;
    isUnavailable?: boolean;
}

export const OfferBoxPill = (props: IProps) => {
    const Icon = props.icon;

    return (
        <div css={wrapperStyle}>
            {!props.isArchived && (
                <div css={iconWrapperStyle}>
                    <Icon size="1.6" />
                </div>
            )}
            <Text variant="info_txt_1" color={props.isArchived || props.isUnavailable ? "var(--colors-gray-100)" : "var(--colors-secondary)"} strong>
                {getPillText(props.text, props.isArchived, props.isUnavailable)}
            </Text>
        </div>
    );
};

const getPillText = (text: string, isArchived?: boolean, isUnavailable?: boolean) => {
    if (isUnavailable) {
        return "Oferta nieaktywna";
    }
    if (isArchived) {
        return "Oferta archiwalna";
    }
    return text;
};

const wrapperStyle = (theme: Theme) => css`
    ${p(0, 1)};
    display: inline-flex;
    align-items: center;
    background-color: ${theme.colors.gray[200]};
    ${borderRadius(1)};
    gap: ${calculateRemSize(1)};
    height: ${calculateRemSize(3)};
    user-select: none;
`;

const iconWrapperStyle = css`
    ${flexAbsoluteCenter};
    width: ${calculateRemSize(2)};
    height: ${calculateRemSize(2)};
`;
